/** OAuth params never become page params — they are consumed by auth boot. */
const AUTH_KEYS = ["id_token", "access_token", "session_state", "code", "state"];

export type PageParams = { [key: string]: string | undefined };

export const DEFAULT_PAGE = "defaultContent";

/** Page params from a query string (`?page=x&…` or the OAuth state payload). */
export function parsePageParams(search: string): PageParams {
  const parsed: PageParams = {};
  new URLSearchParams(search).forEach((value, key) => {
    if (!AUTH_KEYS.includes(key)) parsed[key] = value;
  });
  return parsed;
}

export function pageOf(params: PageParams): string {
  return params["page"] || DEFAULT_PAGE;
}

/** The landing page: the default page, or the empty id the brand mark navigates to. */
export const isLandingPage = (page: string): boolean => page === "" || page === DEFAULT_PAGE;
